adNotam.website.space = {
  init: function () {}
};
